"use client";
import {
  Box,
  Button,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogProps,
  Stack,
  Typography,
} from "@mui/material";
import Image from "next/image";
import { Body1, H6 } from "@/styles/theme/components/typography.fontvariant";
import dialogBanner from "./images/Group 427321833.svg";

const ContactUsDialog = (props: DialogProps) => {
  return (
    <>
      <Dialog
        fullWidth
        maxWidth={"sm"}
        sx={{
          [`.${dialogClasses.paper}`]: {
            borderRadius: 0,
          },
        }}
        {...props}
      >
        <DialogContent sx={{ width: 1, p: 1 }}>
          <Box width={1} sx={{ aspectRatio: 459 / 155 }} position={"relative"}>
            <Image src={dialogBanner} alt="" fill />
          </Box>
          <Stack
            maxWidth={357}
            textAlign={"center"}
            alignItems={"center"}
            rowGap={2}
            mx={"auto"}
            my={{ xs: 3, md: 4 }}
          >
            <Typography
              variant="body1"
              color="primary.main"
              fontSize={H6}
              fontWeight={700}
            >
              Details Submitted Successfully
            </Typography>
            <Typography fontSize={Body1} color={"black"}>
              Thank you for submitting your details! We will get back to you
              shortly.
            </Typography>
            <Button
              variant="outlined"
              sx={{ width: { xs: 1, md: 213 } }}
              onClick={() => {
                props.onClose && props.onClose({}, "backdropClick");
              }}
            >
              Done
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContactUsDialog;
